export default {"src":"https://s.sylndr.com/c-d1764eb/_next/static/media/homeicon.d077d1af.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};